module.exports = __webpack_public_path__ + "static/media/avatar.4788048f.png";